// E700 runs on Chrome 52
import 'react-app-polyfill/stable'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import App from './App'
import { store, persistor } from './stores'
import configureServices from './utils/configureServices'

import 'react-toastify/dist/ReactToastify.css'
import './index.scss'
import { VNProvider } from 'vn-react-components/VNProvider'
import { isCacheEnabled, isPreCacheSuccessful } from './VNCache/Utils'
import { register } from './serviceWorkerRegistration'
import { toast } from 'react-toastify'

configureServices()

const Component = (
  <VNProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </VNProvider>
)

const root = createRoot(document.getElementById('root'))
root.render(Component)

// Register Service Workers
if (isCacheEnabled()) {
  register()
  isPreCacheSuccessful().then((isSuccess) => {
    if (isSuccess) return
    toast.error('Error retrieving Application Cache. Try re-enabling it.')
  })
}
